import ChapterEdit from './ChapterEdit';

export default ChapterEdit;
